export function getPlatformEmailPattern() {
  if (typeof window !== "undefined") {
    const runtimePattern = String(window.ENV?.ODP_PLATFORM_EMAIL_PATTERN || "").trim();
    if (runtimePattern) return runtimePattern;
  }

  if (typeof process !== "undefined" && process.env) {
    const buildPattern = String(
      process.env.REACT_APP_ODP_PLATFORM_EMAIL_PATTERN ||
      process.env.ODP_PLATFORM_EMAIL_PATTERN ||
      ""
    ).trim();
    if (buildPattern) return buildPattern;
  }

  return "";
}
